<template>
  <span
    class="bz-social-icon"
    :style="{ color: color, backgroundColor: background }"
    v-html="path"
  />
</template>

<script>
import { socialIconPaths } from '@/enums/SocialIcons'

export default {
  props: {
    name: {
      type: String,
      default: 'facebook',
    },
    color: {
      type: String,
      default: '#ffffff',
    },
    background: {
      type: String,
      default: 'transparent',
    },
  },
  computed: {
    path() {
      return socialIconPaths[this.name] || socialIconPaths.facebook
    },
  },
}
</script>

<style>
.bz-social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 9999px;
  margin: 0 4px 0 4px;
}
.bz-social-icon svg {
  width: 60%;
  height: 60%;
  fill: currentColor;
}
</style>
